module.exports = __webpack_public_path__ + "static/media/presonus@2x.6f33e9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/audio/presonus@2x.png
// module id = 331
// module chunks = 0